import { render, staticRenderFns } from "./CompaniesNarrative.vue?vue&type=template&id=94b6df30"
import script from "./CompaniesNarrative.vue?vue&type=script&lang=js"
export * from "./CompaniesNarrative.vue?vue&type=script&lang=js"
import style0 from "./CompaniesNarrative.vue?vue&type=style&index=0&id=94b6df30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports